/**
 * @generated SignedSource<<ebae0f03969db112bb088f69ffe78085>>
 * @relayHash a20c097e1a7def5c9d2bbc9ae1d9251b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af14fdd6541cfb1fc8fd4e7d5760a04e71787cfa33fe36e65842c29811d876c2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityWorkViewContentQuery } from './CapacityWorkViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';
import isReorderingEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/work/row/person-row/../../../../../../is-reordering-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityWorkViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "af14fdd6541cfb1fc8fd4e7d5760a04e71787cfa33fe36e65842c29811d876c2",
    "metadata": {},
    "name": "CapacityWorkViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isreorderingenabledrelayprovidertsx": isReorderingEnabled_provider,
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider
    }
  }
};

export default node;
